import React, { Suspense, lazy, useCallback, useContext } from 'react';
import { useIsMounted } from '@wix/da-hooks/pkg/useIsMounted';
import { getCurrentUser } from '../../../../publicSession/selectors';
import { useSelector } from 'react-redux';
import retry from '../../../../utils/webpack/chunkRetry';
import { getModuleCount, getModuleDataByModuleName } from '@wix/da-gruser-shared/pkg/redux/selectors/modules';
import '@wix/da-gruser-shared/pkg/types';
import { getGruserForDeviation } from '../../../../DeviationPage/redux/helpers';
import cn from 'classnames';
const LoadableGruser = /*#__PURE__*/ lazy(()=>retry(()=>import(/* webpackChunkName: "dgruser" */ '../GruserZoneLocal')));
import s from './LazyGruserZone.scss';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import Grid from '../../../../Grid';
import { useInView } from 'react-intersection-observer';
import { MeasuredCookieType } from '@wix/da-hooks/pkg/useMeasureElement/redux/types';
export const LazyGruserZone = ({ deviation })=>{
    var _deviation_author;
    const { inView, ref } = useInView({
        triggerOnce: true
    });
    const isMounted = useIsMounted();
    const user = useSelector(getCurrentUser);
    const isOwnerView = user.userId === ((_deviation_author = deviation.author) === null || _deviation_author === void 0 ? void 0 : _deviation_author.userId);
    const gruser = getGruserForDeviation(deviation);
    const moduleCount = useSelector((state)=>getModuleCount(state, gruser, 'local', 'exhibitionist'));
    const moduleData = useSelector((state)=>getModuleDataByModuleName(state, gruser, 'exhibitionist'));
    const isMobile = useContext(MobileContext);
    const hasModule = moduleCount > 0;
    const renderLoadingBlock = useCallback(({ height, width, index: itemIndex, style })=>{
        return /*#__PURE__*/ React.createElement("div", {
            key: itemIndex,
            style: style
        }, /*#__PURE__*/ React.createElement("div", {
            className: cn(s['loading'], s['loading-block']),
            style: {
                width,
                height
            }
        }));
    }, []);
    let LoadingView = null;
    if (isMobile) {
        var _moduleData_deviations;
        // The loading grid for mobile
        const LoadingGrid = /*#__PURE__*/ React.createElement(Grid, {
            lazyloadFromContext: true,
            enableScrollOptim: false,
            containerWidth: 308,
            defaultSize: {
                desktop: {
                    width: 308,
                    height: 308
                },
                mobile: {
                    width: 308,
                    height: 308
                }
            },
            cookieType: MeasuredCookieType.DEVIATION_SIDEBAR,
            maxRows: 3,
            breakpoints: [
                {
                    maxWidth: 308,
                    elementsPerRow: 3,
                    elementAspectRatio: 1
                }
            ],
            spacing: 16,
            elementCount: moduleData === null || moduleData === void 0 ? void 0 : (_moduleData_deviations = moduleData.deviations) === null || _moduleData_deviations === void 0 ? void 0 : _moduleData_deviations.length,
            renderElement: renderLoadingBlock
        });
        // Need slightly different views for owner vs visitor as owner needs to see the add button
        LoadingView = isOwnerView ? /*#__PURE__*/ React.createElement("div", {
            ref: ref,
            className: cn(!hasModule && s['lazy-owner-loading-no-module'], hasModule && s['lazy-owner-loading-with-module'])
        }, hasModule && /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("div", {
            className: cn(s['loading'], s['loading-title'])
        }), LoadingGrid)) : /*#__PURE__*/ React.createElement("div", {
            ref: ref,
            className: cn(s['lazy-visitor-loading-with-module'])
        }, /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("div", {
            className: cn(s['loading'], s['loading-title'])
        }), LoadingGrid));
    } else {
        // Desktop
        // Need slightly different views for owner vs visitor as owner needs to see the add button
        LoadingView = isOwnerView ? /*#__PURE__*/ React.createElement("div", {
            ref: ref,
            className: cn(!hasModule && s['lazy-owner-loading-no-module'], hasModule && s['lazy-owner-loading-with-module'])
        }, hasModule && /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("div", {
            className: cn(s['loading'], s['loading-title'])
        }), /*#__PURE__*/ React.createElement("div", {
            className: cn(s['loading'], s['loading-block'])
        }))) : /*#__PURE__*/ React.createElement("div", {
            ref: ref,
            className: cn(s['lazy-visitor-loading-with-module'])
        }, /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("div", {
            className: cn(s['loading'], s['loading-title'])
        }), /*#__PURE__*/ React.createElement("div", {
            className: cn(s['loading'], s['loading-block'])
        })));
    }
    if (!isMounted || !inView) {
        // Don't even load for visitor when no module returned
        // Dont load for owener on mobile as we don't show controls
        if (!isOwnerView && !hasModule || isMobile && !hasModule) {
            return null;
        }
        return LoadingView;
    }
    return /*#__PURE__*/ React.createElement(Suspense, {
        fallback: LoadingView
    }, /*#__PURE__*/ React.createElement(LoadableGruser, {
        deviation: deviation
    }));
};
LazyGruserZone.displayName = 'LazyGruserZone';
export default LazyGruserZone;

//# sourceMappingURL=LazyGruserZone.js.map